import React, { Component } from "react"
import axios from "axios"
import { extractRemoteMarkup } from "../utils/remoteMarkup"
// import { BrowserRouter, Link } from 'react-router-dom';
// import axios from 'axios';

// components

export class Header extends Component {
	state = {
		remoteHeader: null
	}

	cleanupRemoteHeader = []
	setMobileMenuOpen = null

	componentDidMount() {
		this.loadRemoteHeader()
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.remoteHeader !== this.state.remoteHeader && this.state.remoteHeader) {
			this.bindRemoteHeaderInteractions()
		}
	}

	componentWillUnmount() {
		this.teardownRemoteHeaderInteractions()
	}

	loadRemoteHeader = () => {
		axios({
			url: "https://www.usa.edu",
			auth: {
				username: "usahs",
				password: "usahsMarketing"
			}
		})
			.then((resp) => {
				const remoteHeader = extractRemoteMarkup(resp.data, "header.site-header")

				if (remoteHeader) {
					this.setState({ remoteHeader })
				}
			})
			.catch((error) => {
				console.log(error)
			})
	}

	addCleanup = (target, eventName, handler, options) => {
		target.addEventListener(eventName, handler, options)
		this.cleanupRemoteHeader.push(() => {
			target.removeEventListener(eventName, handler, options)
		})
	}

	teardownRemoteHeaderInteractions = () => {
		this.cleanupRemoteHeader.forEach((cleanup) => cleanup())
		this.cleanupRemoteHeader = []
		this.setMobileMenuOpen = null

		document.body.classList.remove("nav-open")

		document
			.querySelectorAll(".submenu-toggle[data-generated-toggle='true']")
			.forEach((button) => button.remove())

		document.querySelectorAll(".mobile-menu .sub-menu").forEach((subMenu) => {
			subMenu.style.display = ""
		})
	}

	bindRemoteHeaderInteractions = () => {
		this.teardownRemoteHeaderInteractions()

		const header = document.querySelector("header.site-header")

		if (!header) {
			return
		}

		this.bindMobileMenu(header)
		this.bindMobileSearch(header)
	}

	bindMobileMenu = (header) => {
		const toggleButton = header.querySelector("#mobile-menu-toggle")
		const panel = header.querySelector("#mobile-navigation")
		const overlay = header.querySelector(".mobile-nav-overlay")
		const closeButton = panel?.querySelector(".mobile-close")

		if (!toggleButton || !panel || !overlay) {
			return
		}

		const setMenuOpen = (isOpen) => {
			toggleButton.classList.toggle("active", isOpen)
			panel.classList.toggle("active", isOpen)
			overlay.classList.toggle("active", isOpen)
			document.body.classList.toggle("nav-open", isOpen)
			toggleButton.setAttribute("aria-expanded", String(isOpen))
			panel.setAttribute("aria-hidden", String(!isOpen))
		}

		this.setMobileMenuOpen = setMenuOpen
		setMenuOpen(false)

		this.addCleanup(toggleButton, "click", (event) => {
			event.preventDefault()
			setMenuOpen(!panel.classList.contains("active"))
		})

		if (closeButton) {
			this.addCleanup(closeButton, "click", (event) => {
				event.preventDefault()
				setMenuOpen(false)
			})
		}

		this.addCleanup(overlay, "click", () => {
			setMenuOpen(false)
		})

		this.addCleanup(document, "keydown", (event) => {
			if (event.key === "Escape") {
				setMenuOpen(false)
			}
		})

		this.addCleanup(window, "resize", () => {
			if (window.innerWidth > 991) {
				setMenuOpen(false)
			}
		})

		panel
			.querySelectorAll(".mobile-menu li.menu-item-has-children")
			.forEach((item) => {
				const link = item.querySelector(":scope > a")
				const subMenu = item.querySelector(":scope > .sub-menu")

				if (!link || !subMenu) {
					return
				}

				let toggle = item.querySelector(":scope > .submenu-toggle")

				if (!toggle) {
					toggle = document.createElement("button")
					toggle.type = "button"
					toggle.className = "submenu-toggle"
					toggle.setAttribute("data-generated-toggle", "true")
					link.insertAdjacentElement("afterend", toggle)
				}

				const label = link.textContent.replace(/\s+/g, " ").trim()

				const setSubmenuOpen = (isOpen) => {
					subMenu.style.display = isOpen ? "block" : "none"
					toggle.textContent = isOpen ? "-" : "+"
					toggle.setAttribute("aria-expanded", String(isOpen))
					toggle.setAttribute("aria-label", `Toggle submenu for ${label}`)
					item.classList.toggle("submenu-open", isOpen)
				}

				setSubmenuOpen(false)

				this.addCleanup(toggle, "click", (event) => {
					event.preventDefault()
					event.stopPropagation()
					setSubmenuOpen(toggle.getAttribute("aria-expanded") !== "true")
				})
			})
	}

	bindMobileSearch = (header) => {
		const searchButton = header.querySelector(".mobile-header-wrapper #ssme-search")
		const searchContainer = header.querySelector(".mobile-header-wrapper .search-me")
		const closeButton = searchContainer?.querySelector(".close-toggler")

		if (!searchButton || !searchContainer) {
			return
		}

		const setSearchOpen = (isOpen) => {
			searchContainer.style.display = isOpen ? "block" : "none"
			searchButton.setAttribute("aria-pressed", String(isOpen))
			searchButton.setAttribute("aria-expanded", String(isOpen))
		}

		setSearchOpen(false)

		this.addCleanup(searchButton, "click", (event) => {
			event.preventDefault()
			if (this.setMobileMenuOpen) {
				this.setMobileMenuOpen(false)
			}
			setSearchOpen(searchButton.getAttribute("aria-pressed") !== "true")
		})

		if (closeButton) {
			this.addCleanup(closeButton, "click", (event) => {
				event.preventDefault()
				setSearchOpen(false)
			})
		}
	}

	render() {
		const { remoteHeader } = this.state

		return <section>{remoteHeader && <div dangerouslySetInnerHTML={{ __html: remoteHeader }} />}</section>
	}
}

export default Header
